export const Messages = {
  CHANGE_STATUS_SUCCESS: 'El estado del rol se ha actualizado correctamente',
  CHANGE_STATUS_USER_SUCCESS: 'El estado del usuario se ha actualizado correctamente',
};
